import { TripPayload } from 'store/trips/trips.types'

const EQUIPMENT_NOTE_PATTERN =
  /Please use the tractor .+ \(Tractor\)(?: and trailer .+ \(Trailer\))? for this trip\./

export function getEquipmentHookTractor(tripTasks: TripPayload[]) {
  return tripTasks.find(
    (task) => task.type === 'HOOK_TRACTOR' && task.orderEventId == null
  )
}

export function getEquipmentHookTrailer(tripTasks: TripPayload[]) {
  return tripTasks.find(
    (task) =>
      task.type === 'HOOK_TRAILER' &&
      task.orderEventId == null &&
      task.sourceOrderPkId == null &&
      !task.orderId
  )
}

export function buildEquipmentNote(tripTasks: TripPayload[]): string | null {
  const tractor = getEquipmentHookTractor(tripTasks)
  const trailer = getEquipmentHookTrailer(tripTasks)

  if (tractor && trailer) {
    return `Please use the tractor ${tractor.name} (Tractor) and trailer ${trailer.name} (Trailer) for this trip.`
  }
  if (tractor) {
    return `Please use the tractor ${tractor.name} (Tractor) for this trip.`
  }
  if (trailer) {
    return `Please use the trailer ${trailer.name} (Trailer) for this trip.`
  }
  return null
}

export function appendEquipmentNote(
  existingNotes: string,
  tripTasks: TripPayload[]
): string {
  const equipmentNote = buildEquipmentNote(tripTasks)
  const cleaned = (existingNotes ?? '')
    .replace(EQUIPMENT_NOTE_PATTERN, '')
    .trim()

  if (!equipmentNote) return cleaned

  if (cleaned.includes(equipmentNote)) return cleaned

  return cleaned ? `${cleaned}\n\n${equipmentNote}` : equipmentNote
}
